import { Hospital } from 'models/hospital'
import { DataTypeColumn } from '../Common/commonColumnHelpers'

export const HOSPITAL_COLUMNS = {
  hospital_name: {
    header: 'Hospital Name',
    group: 'Target Attributes',
  },
  street_addr: {
    header: 'Address',
    group: 'Target Attributes',
    tooltipName: 'opps_full_address',
  },
  city: {
    header: 'City',
    group: 'Target Attributes',
    tooltipName: 'opps_city',
  },
  state: {
    header: 'State',
    group: 'Target Attributes',
    tooltipName: 'opps_state',
  },
  zip_code: {
    header: 'ZIP Code',
    group: 'Target Attributes',
    tooltipName: 'opps_zipcode',
  },
  google_place_url: {
    header: 'Place URL',
    group: 'Target Attributes',
    tooltipName: 'google_place_url',
  },
  meals_per_day: {
    header: 'Est. Meals Per Day',
    group: 'Dining Services',
    tooltipName: 'meals_per_day',
  },
  total_hospital_days: {
    header: 'Hospital Days',
    group: 'Hospital Insights',
    tooltipName: 'total_hospital_days',
  },
  total_hospital_beds: {
    header: 'Hospital Beds',
    group: 'Hospital Insights',
    tooltipName: 'total_hospital_beds',
  },
  cafeteria: {
    header: 'Cafeteria Expenditures',
    group: 'Dining Services',
    tooltipName: 'cafeteria',
  },
  dietary: {
    header: 'Patient Meal Expenditures',
    group: 'Dining Services',
    tooltipName: 'dietary',
  },
  dietary_under_contract: {
    header: 'Contracted Patient Meal Expenditures',
    group: 'Dining Services',
    tooltipName: 'dietary_under_contract',
  },
  domain: {
    header: 'Domain',
    group: 'Target Attributes',
    tooltipName: 'opps_domain',
  },
  website_url: {
    header: 'Website',
    group: 'Target Attributes',
    tooltipName: 'website_url',
  },
} satisfies Partial<Record<keyof Hospital, DataTypeColumn>>
